export default "__VITE_ASSET__2w2BrtV6__"